<template>
  <div class="footer-wrapper">
    <div class="footer-content">
      <div class="footer-left">
        <img src="../assets/newImage/footer.png" style="width: 202px; height: 55px" />
        <div class="desc">
          领点回收，卡券回收界明星平台，全品类覆盖。秉持客户至上，提供 24 小时服务，回收极速响应，流程便捷。</br>提现更是全天可操作，秒到账无延迟。经权威认证，专业可靠，是卡券回收的不二选择 。​
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-item">
          <div class="footer-right-item-title">帮助中心</div>
          <div class="footer-right-item-lable" @click="gotoUser(0)">联系我们</div>
          <div class="footer-right-item-lable" @click="gotoUser(4)">服务协议</div>
          <div class="footer-right-item-lable" @click="gotoUser(8)">常见问题</div>
        </div>
        <!-- <div class="footer-right-item">
          <div class="footer-right-item-title">相关平台</div>
          <div class="footer-right-item-lable">速销卡</div>
          <div class="footer-right-item-lable">闲赚侠</div>
        </div> -->

        <div class="footer-right-item">
          <div class="footer-right-item-title">合作洽谈</div>
<!--          <div class="footer-right-item-lable" @click="gotoUser(99)">商户API</div>-->
          <div class="footer-right-item-lable" @click="gotoUser(2)">卖卡流程</div>
          <div class="footer-right-item-lable" @click="gotoUser(1)">交易方式</div>
        </div>
        <div class="footer-right-item">
          <div class="footer-right-item-title">联系我们</div>
          <div class="footer-right-item-lable">联系客服：{{webConfig.phone}}</div>
          <div class="footer-right-item-lable">
            服务时间：{{webConfig.svctm}}
          </div>
          <div class="footer-right-item-lable">
            联系邮箱：{{ webConfig.email }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom" >
      <div class="footer-bottom-top"v-if="1!=1">
        <div class="footer-bottom-top-item">
          <img src="@/assets/image/wbimg.CviRU_MU.png" alt="" />
          <div>广州市工商<br />行政管理局</div>
        </div>
        <div class="footer-bottom-top-item">
          <img src="@/assets/image/wbimg.CviRU_MU.png" alt="" />
          <div>广州市工商<br />行政管理局</div>
        </div>
        <div class="footer-bottom-top-item">
          <img src="@/assets/image/wbimg.CviRU_MU.png" alt="" />
          <div>广州市工商<br />行政管理局</div>
        </div>
        <div class="footer-bottom-top-item">
          <img src="@/assets/image/wbimg.CviRU_MU.png" alt="" />
          <div>广州市工商<br />行政管理局</div>
        </div>
      </div>
      <div class="footer-bottom-label">
        {{ webConfig.copyright }} <span @click="bottomClick('https://beian.miit.gov.cn/')" >  {{ webConfig.icp }}</span>
<!--        ｜【增值电信业务经营许可证】 冀ICP备2025135202号-1｜<span @click="bottomClick('https://beian.mps.gov.cn/#/')">公安信息冀公网安备13010802002354号</span>-->

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  mounted() {
    this.getWebConfig();
  },
  data() {
    return {
      webConfig: {}
    }
  },
  methods: {

    bottomClick(vl){
      window.open(vl, "_blank");

    },

    pushHandle(path) {
      this.$router.push(path);
    },
    gotoUser(type){
      if(type == 99){
        window.open("https://merchant.huishouka.com.cn", "_blank");
        return
      }
      if(type == 4){
          this.$store.commit('changedLeftChildId',4.4)
      }
      window.scrollTo(0, 0);
      this.$router.push({ path: "/HelpCentre" });
    },
    // 获取网站配置
    getWebConfig() {
      http.get("/config/web").then((response) => {
        console.log(response);
        if (response.code === 200) {
          this.webConfig = response.data;
          // 修改 response.data 接口数据

        }

      })
    },

  },
};
</script>

<style lang="less" scoped>
.footer-wrapper {
  background-color: #38435d;
  padding: 0 70px;
  width: 100%;
  cursor: pointer;
  .flex-column();

  .footer-content {
    margin-top: 40px;
    padding-bottom: 50px;
    display: flex;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);

    .footer-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .desc {
        margin-top: auto;
        font-size: 16px;
        color: white;
        line-height: 30px;
        padding-bottom: 20px;
      }
    }

    .footer-right {
      display: flex;
      flex: 1;
      justify-content: space-evenly;
      align-items: flex-start;

      .footer-right-item {
        display: flex;
        flex-direction: column;
        color: white;
        height: 100%;
        justify-content: flex-start;

        .footer-right-item-title {
          font-size: 20px;
          font-weight: bold;
          flex-shrink: 0;
          margin-bottom: 20px;
        }

        .footer-right-item-lable {
          font-size: 16px;
          margin-top: 20px;
          &:last-child {
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .footer-bottom {
    margin-top: 30px;
    .flex-column-ct();

    .footer-bottom-top {
      display: flex;
      justify-content: space-evenly;

      .footer-bottom-top-item {
        margin-right: 20px;
        width: 116px;
        font-size: 14px;
        color: #00000073;
        height: 46px;
        background-color: white;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
      }
    }

    .footer-bottom-label {
      padding: 20px 0px;
      font-size: 14px;
      color: #ffffff72;
    }
  }
}
</style>
